module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitlea"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('strong', [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter_01#fig1"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("1")]), _vm._v(" Strong Vincent as a young man, c. 1860")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#fig2"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("2")]), _vm._v(" Colonel John W. McLane, c. 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#fig3"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("3")]), _vm._v(" Private Oliver W. Norton, c. 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#fig4"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("4")]), _vm._v(" Lieutenant Amos M. Judson, 1862")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter_03#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("5")]), _vm._v(" Lieutenant Strong Vincent, c. 1861")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter_05#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("6")]), _vm._v(" Color Sergeant Alex Rogers with the 83rd Pennsylvania’s flag, 1862")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter_06#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("7")]), _vm._v(" Elizabeth Carter Vincent, c. 1850s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter_06#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("8")]), _vm._v(" Colonel Strong Vincent, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter_11#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("9")]), _vm._v(" Marble marker to Vincent on Little Round Top")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter_11#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("10")]), _vm._v(" Grave of Brigadier General Vincent in Erie Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter_11#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("11")]), _vm._v(" Inscription on the boulder where Vincent was mortally wounded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter_11#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_vm._v("12")]), _vm._v(" The monument to the 83rd Pennsylvania at Gettysburg")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-834fa94e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_illustrations.vue
// module id = 72
// module chunks = 0